import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTypesOfScoreAction } from "../actions";
import { getLoading, getData } from "../selectors";
import { getAppColor } from "@icarius-app/selectors";
import { RESET_STATE } from "../actionTypes";
import { getFiltersIsLoading } from "@icarius-common/filtersDialog/selectors";
import { getTheme } from "@icarius-pages/login/selectors";

const useTypesOfScore = () => {
    const [createTypeOfScoreIsOpen, setCreateTypeOfScoreIsOpen] = useState(false);

    const dispatch = useDispatch();
    const gridTheme = useSelector(getTheme);

    useEffect(() => {
        dispatch(getTypesOfScoreAction());
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch]);

    const color = useSelector(getAppColor);
    const data = useSelector(getData);
    const isLoadingLocal = useSelector(getLoading);
    const filtersIsLoading = useSelector(getFiltersIsLoading);
    const isLoading = isLoadingLocal || filtersIsLoading;

    return {
        gridTheme,
        color,
        data,
        isLoading,
        createTypeOfScoreIsOpen,
        setCreateTypeOfScoreIsOpen,
    };
};

export default useTypesOfScore;
